var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.84 14C13.62 14 13.43 14.04 13.27 14.12L10.36 15.44C10.12 15.56 10 15.74 10 15.98V17.72C10 17.86 10.03 17.97 10.09 18.05C10.17 18.13 10.27 18.17 10.39 18.17C10.45 18.17 10.5 18.16 10.54 18.14L13.33 17.36C13.47 17.32 13.54 17.37 13.54 17.51V34.52C13.54 34.84 13.7 35 14.02 35H16.54C16.86 35 17.02 34.84 17.02 34.52V14.48C17.02 14.16 16.86 14 16.54 14H13.84Z",
    fill: "#A79FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8216 25.1428C40.3776 25.4081 40.9605 24.821 40.5874 24.3308C38.1214 21.0912 34.2242 19 29.8387 19C25.4531 19 21.556 21.0911 19.0901 24.3307C18.717 24.8208 19.2998 25.4079 19.8558 25.1427C21.3238 24.4423 22.9556 23.8922 24.704 23.5248C24.468 24.1378 24.3387 24.8038 24.3387 25.5C24.3387 28.5376 26.8011 31 29.8387 31C32.8762 31 35.3387 28.5376 35.3387 25.5C35.3387 24.8038 35.2093 24.1379 34.9733 23.5248C36.7217 23.8923 38.3536 24.4424 39.8216 25.1428ZM33.3387 25.5C33.3387 27.433 31.7716 29 29.8387 29C27.9057 29 26.3387 27.433 26.3387 25.5C26.3387 23.567 27.9057 22 29.8387 22C31.7716 22 33.3387 23.567 33.3387 25.5Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.1cc6d4072ae504760ac37d3dd108e5e7.svg";
export { ForwardRef as ReactComponent };